import React from 'react';

// True when a menu item's focusable container has keyboard focus (:focus-visible).
// Provided by CheckboxItem and RadioItem in NvDropdown so that
// NvTruncatedTextWithTooltip can show its tooltip without being the focused element.
const MenuItemKeyboardFocusContext = React.createContext(false);

export default MenuItemKeyboardFocusContext;
